export const DEFAULT_MAX_IMAGE_SIZE_IN_MB = 2;

export const DEFAULT_MAX_DOCUMENTS_PER_EMPLOYEE = 25;
